module.exports = __webpack_public_path__ + "static/media/event.c580fe62.jpg";